module.exports = __webpack_public_path__ + "static/media/telurNew.5964aa35.png";